import { useWindowDimensions } from '@hooks';

export const useAvatarCalculator = () => {
  const { width } = useWindowDimensions();

  if (width <= 640) return 200;
  if (width <= 1280) return 300;
  if (width >= 1920) return 550;

  return 400;
};
